import { render, staticRenderFns } from "./aggregates_loader.vue?vue&type=template&id=1015c50e&scoped=true&"
import script from "./aggregates_loader.vue?vue&type=script&lang=js&"
export * from "./aggregates_loader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1015c50e",
  null
  
)

export default component.exports